import { gql } from "@apollo/client";

export default gql`
  query getKpiGroupQuery($kpiGroupId: Int!) {
    kpiGroup(kpiGroupId: $kpiGroupId) {
      id
      title
      canDelete {
        permission
        reason
      }
      canUpdate {
        permission
        reason
      }
    }
  }
`;
